<div
  class="coverage-notice__backdrop"
  [class.coverage-notice__backdrop--visible]="open()"
  aria-hidden="true"
></div>

@if (open()) {
  <section
    #dialog
    class="coverage-notice"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="coverage-notice-title"
    aria-describedby="coverage-notice-body"
    tabindex="-1"
  >
    <div class="coverage-notice__header">
      @if (mascotSrc()) {
        <img
          class="coverage-notice__mascot"
          [src]="mascotSrc()"
          alt=""
          loading="lazy"
          [width]="mascotWidth()"
          [height]="mascotHeight()"
        />
      }
      <div class="coverage-notice__text">
        <h2 id="coverage-notice-title" class="coverage-notice__title">{{ title() }}</h2>
        <p id="coverage-notice-body" class="coverage-notice__body">{{ body() }}</p>
      </div>
    </div>

    <div class="coverage-notice__actions">
      <app-button variant="primary" size="md" type="button" (click)="onAcknowledge()">
        {{ ctaLabel() }}
      </app-button>
    </div>
  </section>
}
